import { TrailVisual } from './TrailVisual';
export class AirPaintVisual extends TrailVisual { constructor(){super(900);} }
